import { Button, Center, Text, VStack } from "@chakra-ui/react";
import React, { ReactNode } from "react";
import { useAuth } from "../contexts/AuthContext";
import GlobalLoading from "./GlobalLoading";

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRoles = [],
}) => {
  const { isAuthenticated, isLoading, roles, logout, login, user } = useAuth();

  const allowed = requiredRoles.some((role) => roles.includes(role));

  if (isLoading) {
    return (
      <Center height="200px">
        <GlobalLoading />
      </Center>
    );
  }
  if (!isAuthenticated && !isLoading) {
    // Instead of redirecting, show inline login prompt for better UX
    return (
      <Center height="50vh">
        <VStack gap={4}>
          <Text fontSize="lg" color="gray.600">
            Please sign in to access this page
          </Text>
          <Text fontSize="sm" color="gray.500">
            You'll be redirected to Keycloak for secure authentication
          </Text>
          <Button onClick={() => login()}>Log in</Button>
        </VStack>
      </Center>
    );
  }
  if (user && requiredRoles.length > 0 && !allowed && !isLoading) {
    return (
      <Center p={8}>
        <VStack gap={4}>
          <Text fontSize="xl" fontWeight="bold" color="red.500">
            Access Denied!
          </Text>
          <Text textAlign="center" color="gray.600">
            You don't have permission to access this page. Required roles:{" "}
            {requiredRoles.join(", ")}
          </Text>
        </VStack>
      </Center>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
